export function textTag(textArray, identifier) {
    return textArray.find((item) => item.identifier === identifier).text;
}
